import { dequal } from 'dequal'
import { HostEnvironment } from '@typesApp/Environment'

export const isEnvironmentChanged = (
  source: HostEnvironment | undefined,
  target: HostEnvironment | undefined
): boolean => {
  return !dequal(source, target)
}

export const initGlobalLocale = (environment: HostEnvironment) => {
  if (window.directBilling?.env) {
    window.directBilling.env.locale = environment.locale
    window.directBilling.env.currency = environment.currency
  }
}
